import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'hooks/useNavigate';
import { RoutePath } from 'enums/Routes';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import FormContainer from 'components/LoanForm/FormContainer';
import { getPaymentAccount } from 'thunks';
import { getApplicationData } from 'selectors/getApplicationData';
import { getPaymentAccountData } from 'selectors/paymentAccount';

import DecisionButtons, { DecisionOptions } from './components/DecisionButtons';

const ManualDeduction = () => {
  const navigate = useNavigate();
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const { bankAccountData } = useSelector(getPaymentAccountData);
  const applicationId = useSelector(getApplicationData).application?.id;

  useEffect(() => {
    (async () => {
      if (applicationId && !bankAccountData) {
        await dispatchWithUnwrap(getPaymentAccount({ applicationId }));
      }
    })();
  }, [bankAccountData]);

  const handleContinue = (manualDeductionMethod: DecisionOptions) => {
    if (manualDeductionMethod === DecisionOptions.No) {
      navigate(RoutePath.NotifyYourTeam);
    } else {
      navigate(RoutePath.PaystubsSignInGuide);
    }
  };

  return (
    <FormContainer title="Do you have access to your paystubs online?">
      <DecisionButtons handleContinue={handleContinue} />
    </FormContainer>
  );
};

export default ManualDeduction;
